// Domain types for the Admin Text Blocks MSPA.

// A row in the text blocks list table.
export interface TextBlock {
  id: string;
  name: string;
  // Server-derived merge id (slug); read-only, never written by the client.
  slug: string;
}

// Controlled values for the text block create/edit form.
export interface TextBlockFormValues {
  name: string;
  mergeBlock: string;
}

export const emptyTextBlockForm: TextBlockFormValues = {
  name: "",
  mergeBlock: "",
};
